import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
    extendedStyles?: ADIProductImageStyles;
    sourceName: string;
}

type Props = OwnProps;

export interface ADIProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
}

export const adiProductImageStyles: ADIProductImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 100%;
        `,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: auto;
            width: 100%;
        `,
    },
};

const ADIProductImage: FC<Props> = ({ product, extendedStyles,sourceName }) => {
    const [styles] = React.useState(() => mergeToNew(adiProductImageStyles, extendedStyles));

    let altText = product.imageAltText;
    if (!altText || altText === "") {
        altText = product.productTitle;
    }

    const clickHandler = () => {
        sessionStorage.setItem("item_list_name", sourceName);
    };
    // below OOTB code has been commented to address the requirement of the ticket ADINA-45633.
    // altText += ` ${translate("redirect to product page")}`;
    let imagePath = product.mediumImagePath || product.smallImagePath;
    if(imagePath == null){
        imagePath = "https://cdn.adiglobaldistribution.us/userfile-na/US/UserFiles/Images/Products/MD_NotFound.jpg";
    }
    const urlSegment = `/Product/${product.urlSegment}`;
    const productDetailPath = product.productDetailUrl || urlSegment;
    const loading = "lazy";

    return (
        <Clickable {...styles.linkWrappingImage} href={productDetailPath} data-test-selector="adiProductImage">
            <Img {...styles.img} loading={loading} src={imagePath} altText={altText} onClick={clickHandler}/>
        </Clickable>
    );
};

export default ADIProductImage;
